import React from 'react'

const Home = props => (
  <svg width={24} height={24} {...props}>
    <path
      d="M11.706 4.056c-.032.011-.058.029-.088.046-.036.018-.075.03-.108.055L2.343 10.96l.009.013a.841.841 0 00.481 1.525.798.798 0 00.482-.175l.008.013.344-.255v8.07c0 .468.375.85.833.85h15a.845.845 0 00.833-.85v-8.07l.344.255.008-.013a.8.8 0 00.482.175.841.841 0 00.481-1.525l.009-.013-9.167-6.802c-.033-.024-.072-.035-.107-.055-.03-.015-.057-.034-.09-.046A.812.812 0 0012 4a.807.807 0 00-.293.056zm-6.373 6.788L12 5.897l6.667 4.947V19.3H5.333v-8.456z"
      fill={props.fill}
    />
  </svg>
)

export default Home
